/** Канарейка: фронт упал — сервер узнал. Дедуп по сообщению раз
 *  в минуту, любые сбои отправки молча глотаем. Осознанный дубль
 *  файла между приложениями — как UpdateBanner. */
const lastSent = new Map<string, number>();

function report(app: 'pos' | 'kds' | 'backoffice' | 'menu', message: string, stack?: string) {
  const now = Date.now();
  const prev = lastSent.get(message) ?? 0;
  if (now - prev < 60_000) return;
  lastSent.set(message, now);
  const build = typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'dev';
  void fetch('/api/v1/public/client-error', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      app, message: message.slice(0, 500),
      ...(stack ? { stack: stack.slice(0, 4000) } : {}),
      url: window.location.pathname.slice(0, 300),
      // Какой раздел был открыт. Стек минифицирован и без этого
      // читается только по картам кода — а раздел виден сразу
      screen: localStorage.getItem('dastarhan.screen') ?? undefined,
      build,
    }),
  }).catch(() => undefined);
}

declare const __BUILD_ID__: string | undefined;

export function installCrashReporter(app: 'pos' | 'kds' | 'backoffice' | 'menu') {
  window.addEventListener('error', (e) => {
    report(app, e.message || 'unknown error', e.error instanceof Error ? e.error.stack : undefined);
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    report(app, r instanceof Error ? r.message : String(r).slice(0, 200),
      r instanceof Error ? r.stack : undefined);
  });
}
